import React, { useState, useEffect } from 'react'
import useStateRef from 'react-usestateref';
import Helper from '../Helper';
import { useSelector, useDispatch } from 'react-redux';
import { useHistory, useLocation } from 'react-router-dom/cjs/react-router-dom.min';
import { updateProfileDetailsAction } from '../../middleware/updateProfileDetailsAction';

export const CbSchoolRegister = ({ containerObject, templateName, contentId, dataZone }) => {
    const history = useHistory()
    const [showTooltip, setShowTooltip] = useState(false);
    const [isLoading, setIsLoading] = useState(false);
    const [errorMessage, setErrorMessage, setErrorMessageRef] = useStateRef();
    const [accountNumber, setAccountNumber] = useState();
    const profileDetail = useSelector(state => state.getProfileDetails.profileDetails)
    const dispatch = useDispatch();
    const location = useLocation();
    const isRegisterFromConfirm = location.state ? location.state : false;
    const [currentUrl, setCurrentUrl] = useState();
    const [formData, setFormData, formDataRef] = useStateRef({
        organizationName: '',
        streetAddress: '',
        city: '',
        state: ''
    });
    const [formErrors, setFormErrors, formErrorsRef] = useStateRef({
        organizationName: false,
        streetAddress: false,
        city: false,
        state: false
    });
    const [searchSchool, setSearchSchool, searchSchoolRef] = useStateRef();
    const handleMouseEnter = () => {
        setShowTooltip(true);
    };
    const handleMouseLeave = () => {
        setShowTooltip(false);
    };

    const clearErrMsg = () => {
        document.getElementById("school-message-error-div").classList.remove("d-block")
        document.getElementById("school-message-error-div").classList.add("d-none")
        document.getElementById("school-message-error").innerHTML = ""
    }

    useEffect(() => {
        var url = history.location.pathname
        var splitedUri = url.split("/")
        splitedUri && splitedUri[1] && splitedUri[2] ? setCurrentUrl(splitedUri[1] + "/" + splitedUri[2]) : "";
        if (profileDetail) {
            console.log('currentUrl...',currentUrl);
            if (profileDetail && profileDetail.userType && currentUrl && currentUrl == "account/school") {
                window.location.href = "/"
            }
        }
    }, [profileDetail])

    function handleSubmit(event) {
        event.preventDefault();
        clearErrMsg();
        var actionUrl = event.target.getAttribute('action');
        var formData = new FormData(event.target);
        var formValue = Object.fromEntries(formData.entries());
        // setIsLoading(true);
        fetch(`${window.location.protocol}//${window.location.hostname}/api/rest/cb/profile/${actionUrl}`, {
            method: 'POST',
            headers: new Headers({
                "content-Type": "application/json",
            }),
            body: JSON.stringify(formValue)
        }).then(res => res.json())
            .then(res => {
                if (res.result === "success") {
                    setIsLoading(false)
                    dispatch(updateProfileDetailsAction(true,"register"))
                    // dispatch(registerMsgAction("Your account has successfully been created!"))
                    var redirectPageMap = res.response ? res.response : "";
                    var redirectPage = redirectPageMap.redirectPage ? redirectPageMap.redirectPage : "";
                    // window.location.href = `${window.location.protocol}//${window.location.hostname}${redirectPage}`;
                    
                    if(redirectPageMap?.pricingMode && currentUrl && currentUrl.includes("checkout/school")){
                        history.push("/checkout/cart");
                    }else{
                        // organization user
                    var url = redirectPage;
                    var modifiedUrl = url.replace(".jsp", "");
                    console.log('modifiedUrl----', modifiedUrl)
                    const fullPath = location.pathname + location.search;
                    if (fullPath === '/checkout/school' && profileDetail.miniCartCount !== 0) {
                        console.log('count-1')
                        history.push('/checkout/shipping?create=true')
                    } else {
                        var messageFlag = 'true'
                        fetch(`${window.location.protocol}//${window.location.hostname}/api/rest/cb/profile/landing-message-success/${messageFlag}`, {
                            method: 'GET'
                        }).then(res => res.json())
                            .then(res => {
                                if (res.result === "success") {
                                    dispatch(updateProfileDetailsAction(true,"register"))
                                    var response = (JSON.parse(res.response)).response
                                    if (fullPath === '/checkout/school' && profileDetail.miniCartCount === 0 && !isRegisterFromConfirm) {
                                        console.log('redirectedTo... /checkout/cart');
                                        history.push('/checkout/cart?create=true', response)
                                    }
                                    else if (fullPath === '/checkout/school' && profileDetail.miniCartCount === 0 && isRegisterFromConfirm) {
                                        console.log('redirectedTo... /checkout/confirm');
                                        history.push('/checkout/confirm?create=true', response);
                                    }
                                    else {
                                        if (modifiedUrl.includes('?create=true')) {
                                            console.log('redirectedTo...', modifiedUrl);
                                            history.push(modifiedUrl, response);
                                        } else {
                                            console.log('redirectedTo...', modifiedUrl);
                                            history.push(`${modifiedUrl}?create=true`, response);
                                        }

                                    }
                                } else {
                                }
                            })
                    }
                    }


                    


                } else {
                    setIsLoading(false)
                    var errorMessage = res._ERROR_MESSAGE_;
                    setErrorMessage(errorMessage);
                    // document.getElementById("school-message-error-div").classList.remove("d-none")
                    // document.getElementById("school-message-error-div").classList.add("d-block")
                    var element = document.getElementById("school-message-error");
                    element.innerHTML = setErrorMessageRef.current;
                }
            })

    }

    const handleInstitutionChange = () => {
        document.getElementById("school-address-display").classList.remove("d-block")
        document.getElementById("school-address-display").classList.add("d-none")
        document.getElementById("submitSchoolButton").classList.remove("d-block")
        document.getElementById("submitSchoolButton").classList.add("d-none")
        document.getElementById("find-institution").classList.remove("button-disabled")
        if(isFormValid() && document.getElementById("submit-temp-b2i")){
            console.log('submit-temp-b2i button enabled...');
            document.getElementById("submit-temp-b2i").classList.remove("disabled");
        }
    };

    function handlesearchAccountSubmit(event) {
        event.preventDefault();
        document.getElementById("school-address-display").classList.remove("d-block")
        document.getElementById("school-address-display").classList.add("d-none")
        document.getElementById("submitSchoolButton").classList.remove("d-block")
        document.getElementById("submitSchoolButton").classList.add("d-none")
        document.getElementById('loadingDiv').classList.remove('d-none')
        document.getElementById('loadingDiv').classList.add('d-block')
        var actionUrl = event.target.getAttribute("action")
        var formData = new FormData(event.target)
        var accountNumber = formData.get("accountNumber")
        setAccountNumber(accountNumber)
        // setIsLoading(true)

        const inputMap = {
            accountNumber: accountNumber ? accountNumber : ""
        }
        fetch(`${window.location.protocol}//${window.location.hostname}/api/rest/cb/profile/${actionUrl}`, {
            method: 'POST',
            headers: new Headers({
                "content-Type": "application/json",
            }),
            body: JSON.stringify(inputMap)
        }).then(res => res.json())
            .then(res => {
                if (res.result === 'success') {
                    setSearchSchool(res.response)
                    setIsLoading("false");
                    document.getElementById('loadingDiv').classList.remove("d-block")
                    document.getElementById('loadingDiv').classList.add("d-none")
                    document.getElementById("account-error").classList.remove("d-block")
                    document.getElementById("account-error").classList.add("d-none")
                    document.getElementById("school-address-display").classList.remove("d-none")
                    document.getElementById("school-address-display").classList.add("d-block")
                    document.getElementById("submitSchoolButton").classList.remove("d-none")
                    document.getElementById("submitSchoolButton").classList.add("d-block")
                    document.getElementById("submitSchoolButton").classList.remove("button-disabled")
                    document.getElementById("find-institution").classList.add("button-disabled")
                    document.getElementById("submit-temp-b2i") && document.getElementById("submit-temp-b2i").classList.add("disabled");
                } else {
                    setIsLoading("false");
                    document.getElementById('loadingDiv').classList.remove("d-block")
                    document.getElementById('loadingDiv').classList.add("d-none")
                    setErrorMessage(res._ERROR_MESSAGE_)
                    document.getElementById("account-error").classList.remove("d-none")
                    document.getElementById("account-error").classList.add("d-block")
                    document.getElementById("school-address-display").classList.remove("d-block")
                    document.getElementById("school-address-display").classList.add("d-none")
                    document.getElementById("submitSchoolButton").classList.remove("d-block")
                    document.getElementById("submitSchoolButton").classList.add("d-none")
                }
            })
    }

    const handleCreate = (event) => {
        event.preventDefault();
        //clearErrMsg();
        var actionUrl = event.target.getAttribute('action');
        var formData = new FormData(event.target);
        var formValue = Object.fromEntries(formData.entries());
        // setIsLoading(true);
        fetch(`${window.location.protocol}//${window.location.hostname}/api/rest/cb/profile/${actionUrl}`, {
            method: 'POST',
            headers: new Headers({
                "content-Type": "application/json",
            }),
            body: JSON.stringify(formValue)
        }).then(res => res.json())
            .then(res => {
                if (res.result === "success") {
                    dispatch(updateProfileDetailsAction(true,"register"))
                    setIsLoading(false)
                    var redirectPageMap = res.response ? res.response : "";
                    var redirectPage = redirectPageMap.redirectPage ? redirectPageMap.redirectPage : "";
                    // window.location.href = `${window.location.protocol}//${window.location.hostname}${redirectPage}`;

                    // temp user
                    var url = redirectPage;
                    var modifiedUrl = url.replace(".jsp", "");
                    const fullPath = location.pathname + location.search;
                    if (fullPath === '/checkout/school' && profileDetail.miniCartCount !== 0) {
                        history.push('/checkout/shipping?create=true')
                    } else {
                        var messageFlag = 'true'
                        fetch(`${window.location.protocol}//${window.location.hostname}/api/rest/cb/profile/landing-message-success/${messageFlag}`, {
                            method: 'GET'
                        }).then(res => res.json())
                            .then(res => {
                                if (res.result === "success") {
                                    if (res.result === "success") {
                                        dispatch(updateProfileDetailsAction(true,"register"))
                                        var response = (JSON.parse(res.response)).response
                                       
                                        if (fullPath === '/checkout/school' && profileDetail.miniCartCount === 0 && !isRegisterFromConfirm) {
                                            console.log('redirectedTo... /checkout/cart');
                                            history.push('/checkout/cart?create=true', response)
                                        }
                                        else if (fullPath === '/checkout/school' && profileDetail.miniCartCount === 0 && isRegisterFromConfirm) {
                                            console.log('redirectedTo... /checkout/confirm');
                                            history.push('/checkout/confirm?create=true', response);
                                        }
                                        else {
                                            if (modifiedUrl.includes('?create=true')) {
                                                history.push(modifiedUrl, response);
                                            } else {
                                                history.push(`${modifiedUrl}?create=true`, response);
                                            }
                                        }
                                    } else {
                                    }
                                } else {
                                }
                            })
                    }

                } else {
                    setIsLoading(false)
                    var errorMessage = res._ERROR_MESSAGE_;
                    // setErrorMessage(errorMessage);
                    // document.getElementById("school-message-error-div").classList.remove("d-none")
                    // document.getElementById("school-message-error-div").classList.add("d-block")
                    // var element = document.getElementById("school-message-error");
                    // element.innerHTML = setErrorMessageRef.current;
                }
            })
    }
    const handleInputChange = (e) => {
        const { name, value } = e.target;
        let isError = false;
        // Validate based on field name
        switch (name) {
            case 'organizationName':
                isError = !validateOrganizationName(value);
                break;
            case 'streetAddress':
                isError = !validateStreetAddress(value);
                break;
            case 'city':
                isError = !validateCity(value);
                break;
            case 'state':
                isError = !validateState(value);
            default:
                break;
        }

        setFormData({
            ...formDataRef.current,
            [name]: value
        });

        setFormErrors({
            ...formErrorsRef.current,
            [name]: isError
        });

        console.log('formErrors...',formErrorsRef.current);
        console.log('formData...',formDataRef.current);
    };


    const validateOrganizationName = (value) => {
        // Regex pattern for organization name
        document.getElementById("organizationName_error").innerHTML = "";
        var validation = "^[ A-Za-z0-9_.,/'&-]*$"
        var result = Helper.isEmpty(value)
        var regex = RegExp(validation)
        if (result) {
            document.getElementById("organizationName_error").classList.remove("d-none")
            document.getElementById("organizationName_error").innerHTML = "Organization name should not be empty";
            document.getElementById("organizationName_error").classList.add("d-block")
            return false;
        } else if (!regex.test(value)) {
            document.getElementById("organizationName_error").classList.remove("d-none")
            document.getElementById("organizationName_error").innerHTML = "Organization name should not contain special characters";
            document.getElementById("organizationName_error").classList.add("d-block")
            return false;
        } else {
            return true;
        }
    };
    const validateStreetAddress = (value) => {
        // Regex pattern for street address
        document.getElementById("streetAddress_error").innerHTML = "";
        var validation = "^[a-zA-Z0-9@ ,:;\.'_\(\)\/#\&\s\-]+$"
        var result = Helper.isEmpty(value)
        var regex = RegExp(validation)
        if (result) {
            document.getElementById("streetAddress_error").classList.remove("d-none")
            document.getElementById("streetAddress_error").innerHTML = "Street address should not be empty";
            document.getElementById("streetAddress_error").classList.add("d-block")
            return false;
        } else if (!regex.test(value)) {
            document.getElementById("streetAddress_error").classList.remove("d-none")
            document.getElementById("streetAddress_error").innerHTML = "Street address should not contain special characters";
            document.getElementById("streetAddress_error").classList.add("d-block")
            return false;
        } else {
            return true;
        }
    };
    const validateCity = (value) => {
        // Regex pattern for city
        document.getElementById("city_error").innerHTML = "";
        var validation = "^[a-zA-Z- ]+$"
        var result = Helper.isEmpty(value)
        var regex = RegExp(validation)
        if (result) {
            document.getElementById("city_error").classList.remove("d-none")
            document.getElementById("city_error").innerHTML = "City should not be empty";
            document.getElementById("city_error").classList.add("d-block")
            return false;
        } else if (!regex.test(value)) {
            document.getElementById("city_error").classList.remove("d-none")
            document.getElementById("city_error").innerHTML = "City name is invalid";
            document.getElementById("city_error").classList.add("d-block")
            return false;
        } else {
            return true;
        }
    };

    const validateState = (value) => {
        document.getElementById("state_error").innerHTML = "";
        var result = Helper.isEmpty(value)
        if (result) {
            document.getElementById("state_error").classList.remove("d-none")
            document.getElementById("state_error").innerHTML = "Please select state"
            document.getElementById("state_error").classList.add("d-block")
            return false;
        } else {
            return true;
        }
    };

    const isFormValid = () => {
        if(Object.values(formErrorsRef.current).every((error) => !error) &&
        Object.values(formDataRef.current).every((value) => value.trim() !== '')){
            console.log('isFormValid true');
            document.getElementById('submit-temp-b2i').classList.remove('disabled');
            document.getElementById("submitSchoolButton") && document.getElementById("submitSchoolButton").classList.add("button-disabled");
        }else{
            console.log('isFormValid false');
            document.getElementById("submitSchoolButton") && document.getElementById("submitSchoolButton").classList.remove("button-disabled");
        }
        return (
            Object.values(formErrorsRef.current).every((error) => !error) &&
            Object.values(formDataRef.current).every((value) => value.trim() !== '')
        );
    };

    return (
        <>
            <div data-cont-id={containerObject.contentId} data-zone={dataZone} data-page-id={contentId} data-template-name={templateName} className={`vast-plugin-content c-shop-list-detail`} >
            {profileDetail && profileDetail.transient ?
                <div className="col-12 col-md-11 my-2 mx-lg-5 my-md-5 c-register-wrap">
                    <div className="text-left mt-3">
                        <h1 className="c-account-heading">
                            Link to Your School or Organization
                        </h1>
                    </div>
                    <div id="school-message-error-div" className="d-none alert-danger">
                        <div id="school-message-error" style={{ color: "black" }} dangerouslySetInnerHTML={{ __html: setErrorMessageRef.current }}></div>
                    </div>
                    <div className="text-left mt-3 c-school-margin">
                        <p className="c-regular-text">
                            Providing the information below will help us link your new online login to your school or organization's account. This will provide your login with qualified features like pricing discounts, tax exemption, and purchase order capability.
                        </p>
                    </div>
                    <div className="row c-register-row-wrap">

                        <div className="col-12 col-md-7">
                            <div id="account-error-div" className="message message-red d-none form-error-messages">
                                {/* <div id="account-error" style={{color:"black"}} dangerouslySetInnerHTML={{ __html: setErrorMessageRef.current }}></div> */}
                            </div>
                            <form method="post" action="search-account" id="" className="" onSubmit={handlesearchAccountSubmit}>
                                <div className="message message-red form-error-messages d-none" id="account-error" dangerouslySetInnerHTML={{ __html: setErrorMessageRef.current ? setErrorMessageRef.current : "" }}>
                                </div>
                                <div className="row">
                                    <div className="col-12">
                                        <label className="form-label c-school-label" for="acount">Enter the Carolina Account Number associated with your institution</label>
                                    </div>
                                </div>
                                <div className="row mb-3">
                                    <div className="col-6 col-md-6 mb-3">
                                        <div className="c-input-tooltip c-school-tip">
                                            <input maxlength="8" name="accountNumber" placeholder="6-8 numbers (optional)" onClick={handleInstitutionChange} type="text" className="form-control" />

                                            <span className="c-tooltip" onMouseEnter={handleMouseEnter}
                                                onMouseLeave={handleMouseLeave}
                                                style={{ position: 'relative' }}>
                                                <i className="bi bi-question-circle-fill"></i>
                                                {showTooltip && (
                                                    <div
                                                        style={{
                                                            position: "absolute",
                                                            top: "-168px",
                                                            left: "-90px",
                                                            background: "#fbf3bf",
                                                            padding: "0.875rem",
                                                            zIndex: "1",
                                                            width: "200px",
                                                            border: "0.063rem solid #ccc",
                                                            boxShadow: "0 0 0.625rem #ccc",
                                                            lineHeight: "1.125rem",
                                                            color: "#333",
                                                            borderRadius: "0.313rem",
                                                            fontSize: "0.75rem",
                                                            fontWeight: "400",
                                                            textAlign: "left"
                                                        }}
                                                    >
                                                        <div
                                                            style={{
                                                                position: "absolute",
                                                                top: "155px",
                                                                left: "55 %",
                                                                marginLeft: "78px",
                                                                width: "0px",
                                                                height: "0px",
                                                                borderLeft: "5px solid transparent",
                                                                borderRight: "5px solid transparent",
                                                                borderTop: "8px solid rgb(51, 51, 51)"
                                                            }}
                                                        ></div>
                                                        This is the unique Carolina account number for your organization that we use to provide your online benefits such as pricing and shipping discounts, tax exemption, and much more.
                                                    </div>
                                                )}
                                            </span>
                                        </div>
                                    </div>
                                    <div className="col-6 col-md-6">
                                        <button type="submit" id="find-institution" className="btn btn-primary block c-school-btn" >Find Institution</button>
                                    </div>
                                </div>

                            </form>
                            <div id="loadingDiv" className="address-loader d-none">
                                <div style={{ height: '100%', width: '100%', textAlign: 'center' }} >
                                    <img src="/images/loading-dark.gif" style={{ textAlign: 'center', display: 'inline', paddingTop: '0px' }}></img>
                                    <p style={{ padding: '10px 0 0 0' }}>Loading</p>
                                </div>
                            </div>

                            <address className="form org-address d-none" id="school-address-display" wfd-invisible="true">
                                {searchSchoolRef.current && searchSchoolRef.current.companyName ? searchSchoolRef.current.companyName : ""}<br />
                                {searchSchoolRef.current && searchSchoolRef.current.addr1 ? searchSchoolRef.current.addr1 : ""}<br />
                                {searchSchoolRef.current && searchSchoolRef.current.addr2 ? searchSchoolRef.current.addr2 : ""}<br />
                                {searchSchoolRef.current && searchSchoolRef.current.city ? searchSchoolRef.current.city : ""},&nbsp;{searchSchoolRef.current && searchSchoolRef.current.state ? searchSchoolRef.current.state : ""}&nbsp;{searchSchoolRef.current && searchSchoolRef.current.zip ? searchSchoolRef.current.zip : ""}<br />
                            </address>


                            <div className="form-submit mb-3 c-account-page">
                                <form method="post" action="create-account" id="submit-school" onSubmit={handleSubmit}>
                                    <input type="hidden" id="registrationStep" name="registrationStep" value="2" />
                                    <input type="hidden" id="school" name="school" value={accountNumber} />
                                    <input type="submit" id="submitSchoolButton" className="btn btn-primary button-disabled block text-wrap d-none" value="Continue &amp; Confirm You Are Employee Of This Organization" />
                                </form>
                            </div>
                        </div>
                        <div className="col-12 col-md-5">
                            <div className="c-order-box">
                                <div className="text-left mt-3">
                                    <p className="c-account-heading">Your Account Number</p>
                                </div>
                                <div className="text-left mt-3 mb-2">
                                    <p className="c-regular-text">You need your institution's account number to use receive tax exemption,
                                        special discounts, or purchase order capability with your online account.</p>
                                </div>
                                <div className="c-video-box d-flex">
                                    <div className="c-video-icon">
                                        {/* <i className="bi bi-play-btn-fill"></i> */}
                                        <svg xmlns="http://www.w3.org/2000/svg" width="35" height="35" fill="currentColor" className="bi bi-youtube" viewBox="0 0 16 16">
                                            <path d="M8.051 1.999h.089c.822.003 4.987.033 6.11.335a2.01 2.01 0 0 1 1.415 1.42c.101.38.172.883.22 1.402l.01.104.022.26.008.104c.065.914.073 1.77.074 1.957v.075c-.001.194-.01 1.108-.082 2.06l-.008.105-.009.104c-.05.572-.124 1.14-.235 1.558a2.007 2.007 0 0 1-1.415 1.42c-1.16.312-5.569.334-6.18.335h-.142c-.309 0-1.587-.006-2.927-.052l-.17-.006-.087-.004-.171-.007-.171-.007c-1.11-.049-2.167-.128-2.654-.26a2.007 2.007 0 0 1-1.415-1.419c-.111-.417-.185-.986-.235-1.558L.09 9.82l-.008-.104A31.4 31.4 0 0 1 0 7.68v-.123c.002-.215.01-.958.064-1.778l.007-.103.003-.052.008-.104.022-.26.01-.104c.048-.519.119-1.023.22-1.402a2.007 2.007 0 0 1 1.415-1.42c.487-.13 1.544-.21 2.654-.26l.17-.007.172-.006.086-.003.171-.007A99.788 99.788 0 0 1 7.858 2h.193zM6.4 5.209v4.818l4.157-2.408z" />
                                        </svg>
                                    </div>
                                    <div className="c-video-content">
                                        <a href="http://bcove.me/s3h5fagp" target="_blank" className="c-video-link">Watch video showing where to find this number on your invoice.</a>
                                    </div>
                                </div>
                            </div>
                            <div className="c-customer-service">
                                <p><em>Customer Service Hours: 8am-6pm (EST) Monday-Friday</em></p>
                                <div className="row c-customer-service-custom">
                                    <div className="col-6 col-md-6">
                                        <div className="c-cust-info">
                                            <svg xmlns="http://www.w3.org/2000/svg" width="21" height="21" fill="currentColor" className="bi bi-telephone-fill" viewBox="0 0 16 16">
                                                <path fill-rule="evenodd" d="M1.885.511a1.745 1.745 0 0 1 2.61.163L6.29 2.98c.329.423.445.974.315 1.494l-.547 2.19a.678.678 0 0 0 .178.643l2.457 2.457a.678.678 0 0 0 .644.178l2.189-.547a1.745 1.745 0 0 1 1.494.315l2.306 1.794c.829.645.905 1.87.163 2.611l-1.034 1.034c-.74.74-1.846 1.065-2.877.702a18.634 18.634 0 0 1-7.01-4.42 18.634 18.634 0 0 1-4.42-7.009c-.362-1.03-.037-2.137.703-2.877L1.885.511z" />
                                            </svg>
                                            <span>800.334.5551</span>
                                        </div>
                                    </div>

                                    <div className="col-6 col-md-6">
                                        <div className="c-cust-info row">
                                            <svg xmlns="http://www.w3.org/2000/svg" fill="currentColor" viewBox="0 0 16 16" width="22" height="22" className="bi bi-chat-fill col-3 col-lg-3 mx-0">
                                                <path d="M8 15c4.418 0 8-3.134 8-7s-3.582-7-8-7-8 3.134-8 7c0 1.76.743 3.37 1.97 4.6-.097 1.016-.417 2.13-.771 2.966-.079.186.074.394.273.362 2.256-.37 3.597-.938 4.18-1.234A9.06 9.06 0 0 0 8 15"></path>
                                            </svg>
                                            <p style={{marginLeft: "-20px"}} className="col-8 col-lg-8" dangerouslySetInnerHTML={{ __html: `<a className="c-cust-link" onclick="javascript:showChat();" style="cursor:pointer">Live Chat</a>` }}></p>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div >

                    <div className="text-left mt-3">
                        <p className="c-account-heading">
                            <strong>Can't Find It? That's Okay!</strong>
                        </p>
                    </div>

                    <div className="text-left mt-3 mb-3">
                        <p className="c-regular-text">
                            If you can't find your Carolina Account Number, simply fill in the information below to continue. After your first order, our Customer Service
                            representatives will find and link your online login with your school or organization's account.
                        </p>
                    </div>

                    <form method="post" action="/create-school-account" className="c-account-page" data-hs-cf-bound="true" onSubmit={handleCreate}>
                        <div className="row g-3 mb-3">
                            <div className="col-md-6">
                                <label className="form-label" for="schoolOrOrganization">School/District or Organization Name</label>
                                <input maxlength="40" name="organizationName" id="organizationName" placeholder="Ex: Where invoices are sent" type="text" className="form-control" value={formDataRef.current?.organizationName}
                                    onChange={handleInputChange} />
                                <label className='d-none' id="organizationName_error" style={{ color: 'red', fontSize: '.813rem' }}></label>
                            </div>
                        </div>

                        <div className="row g-3 mb-3">
                            <div className="col-md-6">
                                <label className="form-label" for="streetAddress">Street Address</label>
                                <input maxlength="40" name="streetAddress" id="streetAddress" type="text" className="form-control"
                                    value={formDataRef.current.streetAddress} onChange={handleInputChange} />
                                <label className='d-none' id="streetAddress_error" style={{ color: 'red', fontSize: '.813rem' }}></label>
                            </div>
                        </div>

                        <div className="row g-3 mb-3">
                            <div className="col-12 col-md-3">
                                <label className="form-label" for="city">City</label>
                                <input maxlength="30" name="city" id="city" type="text" className="form-control"
                                    value={formDataRef.current.city} onChange={handleInputChange} />
                                <label className='d-none' id="city_error" style={{ color: 'red', fontSize: '.813rem' }}></label>
                            </div>
                            <div className="col-12 col-md-3">
                                <label className="form-label" for="state">State</label>
                                <select name="state" id="state" style={{ height: '32px' }} className="form-control" onChange={handleInputChange}>
                                    <option selected=""></option>
                                    <option value="AL">
                                        AL - Alabama
                                    </option>
                                    <option value="AK">
                                        AK - Alaska
                                    </option>
                                    <option value="AZ">
                                        AZ - Arizona
                                    </option>

                                    <option value="AR">
                                        AR - Arkansas
                                    </option>

                                    <option value="CA">
                                        CA - California
                                    </option>

                                    <option value="CO">
                                        CO - Colorado
                                    </option>

                                    <option value="CT">
                                        CT - Connecticut
                                    </option>

                                    <option value="DE">
                                        DE - Delaware
                                    </option>

                                    <option value="DC">
                                        DC - District of Columbia
                                    </option>

                                    <option value="FL">
                                        FL - Florida
                                    </option>

                                    <option value="GA">
                                        GA - Georgia
                                    </option>

                                    <option value="HI">
                                        HI - Hawaii
                                    </option>

                                    <option value="ID">
                                        ID - Idaho
                                    </option>

                                    <option value="IL">
                                        IL - Illinois
                                    </option>

                                    <option value="IN">
                                        IN - Indiana
                                    </option>

                                    <option value="IA">
                                        IA - Iowa
                                    </option>

                                    <option value="KS">
                                        KS - Kansas
                                    </option>

                                    <option value="KY">
                                        KY - Kentucky
                                    </option>

                                    <option value="LA">
                                        LA - Louisiana
                                    </option>

                                    <option value="ME">
                                        ME - Maine
                                    </option>

                                    <option value="MD">
                                        MD - Maryland
                                    </option>

                                    <option value="MA">
                                        MA - Massachusetts
                                    </option>

                                    <option value="MI">
                                        MI - Michigan
                                    </option>

                                    <option value="MN">
                                        MN - Minnesota
                                    </option>

                                    <option value="MS">
                                        MS - Mississippi
                                    </option>

                                    <option value="MO">
                                        MO - Missouri
                                    </option>

                                    <option value="MT">
                                        MT - Montana
                                    </option>

                                    <option value="NE">
                                        NE - Nebraska
                                    </option>

                                    <option value="NV">
                                        NV - Nevada
                                    </option>

                                    <option value="NH">
                                        NH - New Hampshire
                                    </option>

                                    <option value="NJ">
                                        NJ - New Jersey
                                    </option>

                                    <option value="NM">
                                        NM - New Mexico
                                    </option>

                                    <option value="NY">
                                        NY - New York
                                    </option>

                                    <option value="NC">
                                        NC - North Carolina
                                    </option>

                                    <option value="ND">
                                        ND - North Dakota
                                    </option>

                                    <option value="OH">
                                        OH - Ohio
                                    </option>

                                    <option value="OK">
                                        OK - Oklahoma
                                    </option>

                                    <option value="OR">
                                        OR - Oregon
                                    </option>

                                    <option value="PA">
                                        PA - Pennsylvania
                                    </option>

                                    <option value="RI">
                                        RI - Rhode Island
                                    </option>

                                    <option value="SC">
                                        SC - South Carolina
                                    </option>

                                    <option value="SD">
                                        SD - South Dakota
                                    </option>

                                    <option value="TN">
                                        TN - Tennessee
                                    </option>

                                    <option value="TX">
                                        TX - Texas
                                    </option>

                                    <option value="UT">
                                        UT - Utah
                                    </option>

                                    <option value="VT">
                                        VT - Vermont
                                    </option>

                                    <option value="VA">
                                        VA - Virginia
                                    </option>

                                    <option value="WA">
                                        WA - Washington
                                    </option>

                                    <option value="WV">
                                        WV - West Virginia
                                    </option>

                                    <option value="WI">
                                        WI - Wisconsin
                                    </option>

                                    <option value="WY">
                                        WY - Wyoming
                                    </option>
                                </select>
                                <label className='d-none' id="state_error" style={{ color: 'red', fontSize: '.813rem' }}></label>

                            </div>
                        </div>

                        <div className="row g-3 mb-4">
                            <div className="col-md-6">
                                <label className="form-label" for="helpUs">Help Us Find You (optional)</label>
                                <input name="organizationAddress" type="hidden" />
                                <textarea maxlength="400" name="organizationAddress" className="form-control c-text-area" placeholder="Please share other information that will help us find your organization's account, including: department name, city, state, building where bills are sent. etc..."></textarea>
                            </div>
                        </div>
                        <input name="tempB2I" type="hidden" value="true" />
                        <div className="row g-3 mb-3">
                            <div className="col-md-6 d-grid">
                                <button id='submit-temp-b2i' type="submit" className={`btn btn-primary block c-sch-continue text-wrap ${!isFormValid() && "disabled"}`} value="Continue &amp; Confirm You Are an Employee of this Organization">Continue &amp; Confirm You Are an Employee of this Organization</button>
                            </div>
                        </div>
                    </form>
                </div >
            :<></>}
            </div >
        </>
    )
}
